import { FaPlus } from "react-icons/fa";
import { FaX } from "react-icons/fa6";
import ButtonElement from "../../../Common/ButtonElement";
import InputElement from "../../../Common/InputElement";
import AsyncInputField from "../../../Common/AsyncInputElement";

const RequestItem = ({ requestType, onChangeHandler, isUpdate, isBlankSim, vehicleNo, vehicleNoErr, removeItem, gpsImeiNo, gpsImeiNoErr, expiryDate, addItems, simNum, simNumErr, simIccidNo, simIccidNoErr, isCompleted, handleDropDownSelect, setErrorGps, fetchSuggestions }) => {
    return <div className="row px-0 mx-0 align-items-start">
        <div className={`col-lg-${isUpdate ? 12 : 11}`}>
            <div className="row">
                {requestType == 1 ? <>
                    <div className={`col-lg-4 mb-2`}>
                        <InputElement
                            label={"Vehicle reg no"}
                            placeholder={"Select Vehicle reg no"}
                            name={"vehicleNo"}
                            value={vehicleNo}
                            error={vehicleNoErr}
                            onChange={onChangeHandler}
                        />
                    </div>

                    <div className={`col-lg-4 mb-2`}>
                        <AsyncInputField
                            disabled={isUpdate}
                            previewKey={"SearchItem"}
                            value={gpsImeiNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "GPS")}
                            name="gpsImeiNo"
                            label={`GPS IMEI number`}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "gpsImeiNo" })}
                            placeholder={`Search GPS IMEI number`}
                            error={gpsImeiNoErr}
                            setError={(err) => setErrorGps("gpsImeiNo", err)}
                        />
                    </div>
                    <div className={`col-lg-4 mb-2`}>
                        <InputElement
                            type="date"
                            label={"Vehicle Expiry Date"}
                            placeholder={"Enter Expiry Date"}
                            name={"expiryDate"}
                            value={expiryDate}
                            isRequired={false}
                            error={false}
                            onChange={onChangeHandler}
                        />
                    </div>
                </> : requestType == 2 ? <>
                    <div className={`col-lg-4 mb-2`}>
                        <AsyncInputField
                            previewKey={"vehicleRegno"}
                            value={vehicleNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "vehicle")}
                            name="vehicleNo"
                            label={"Vehicle reg no"}
                            placeholder={"Search Vehicle reg no"}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "vehicleNo" })}
                            error={vehicleNoErr}
                            setError={(err) => setErrorGps("vehicleNo", err)}
                        />
                    </div>
                    <div className={`col-lg-4 mb-2`}>
                        <InputElement
                            disable={true}
                            value={simNum}
                            name="simNum"
                            label={`Existing GPS IMEI number`}
                            onChange={onChangeHandler}
                            placeholder={`Existing GPS IMEI number`}
                            error={simNumErr}
                        />
                    </div>
                    <div className={`col-lg-4 mb-2`}>
                        <AsyncInputField
                            previewKey={"SearchItem"}
                            value={gpsImeiNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "GPS")}
                            name="gpsImeiNo"
                            label={`GPS IMEI number`}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "gpsImeiNo" })}
                            placeholder={`Search GPS IMEI number`}
                            error={gpsImeiNoErr}
                            setError={(err) => setErrorGps("gpsImeiNo", err)}
                        />
                    </div>
                </> : requestType == 3 ? <>
                    <div className={`col-lg-3 mb-2`}>
                        <AsyncInputField
                            previewKey={"vehicleRegno"}
                            value={vehicleNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "vehicle")}
                            name="vehicleNo"
                            label={"Vehicle reg no"}
                            placeholder={"Search Vehicle reg no"}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "vehicleNo" })}
                            error={vehicleNoErr}
                            setError={(err) => setErrorGps("vehicleNo", err)}
                        />
                    </div>
                    <div className={`col-lg-3 mb-2`}>
                        <InputElement
                            disable={true}
                            value={gpsImeiNo}
                            name="gpsImeiNo"
                            label={`GPS IMEI number`}
                            onChange={onChangeHandler}
                            placeholder={`Enter GPS IMEI number`}
                            error={gpsImeiNoErr}
                        />
                    </div>
                    <div className={`col-lg-3 mb-2`}>
                        <AsyncInputField
                            previewKey={"SearchItem"}
                            value={simIccidNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "SIM")}
                            name="simIccidNo"
                            label={"New Sim ICCID no."}
                            placeholder={"Search New Sim ICCID no."}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "simIccidNo" })}
                            error={simIccidNoErr}
                            setError={(err) => setErrorGps("simIccidNo", err)}
                        />
                    </div>
                    <div className={`col-lg-3 mb-2`}>
                        <InputElement
                            disable={!isBlankSim}
                            value={simNum}
                            name="simNum"
                            label={`SIM Number`}
                            onChange={onChangeHandler}
                            placeholder={`Enter SIM Number`}
                            error={simNumErr}
                        />
                    </div>
                </> : requestType == 4 ? <>
                    <div className={`col-lg-3 mb-2`}>
                        <AsyncInputField
                            previewKey={"vehicleRegno"}
                            value={vehicleNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "vehicle")}
                            name="vehicleNo"
                            label={"Vehicle reg no"}
                            placeholder={"Search Vehicle reg no"}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "vehicleNo" })}
                            error={vehicleNoErr}
                            setError={(err) => setErrorGps("vehicleNo", err)}
                        />
                    </div>
                    <div className={`col-lg-3 mb-2`}>
                        <InputElement
                            disable={true}
                            value={gpsImeiNo}
                            name="gpsImeiNo"
                            label={`GPS IMEI number`}
                            onChange={onChangeHandler}
                            placeholder={`Enter GPS IMEI number`}
                            error={gpsImeiNoErr}
                        />
                    </div>
                    <div className={`col-lg-3 mb-2`}>
                        <InputElement
                            disable={true}
                            value={simNum}
                            name="simNum"
                            label={`SIM Number`}
                            onChange={onChangeHandler}
                            placeholder={`Enter SIM Number`}
                            error={simNumErr}
                        />
                    </div>
                    <div className={`col-lg-3 mb-2`}>
                        <AsyncInputField
                            previewKey={"SearchItem"}
                            value={simIccidNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "SIM")}
                            name="simIccidNo"
                            label={"New Sim ICCID no."}
                            placeholder={"Search New Sim ICCID no."}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "simIccidNo" })}
                            error={simIccidNoErr}
                            setError={(err) => setErrorGps("simIccidNo", err)}
                        />
                    </div>
                </> : requestType == 5 ? <>
                    <div className={`col-lg-4 mb-2`}>
                        <InputElement
                            label={"Vehicle reg no"}
                            placeholder={"Select Vehicle reg no"}
                            name={"vehicleNo"}
                            value={vehicleNo}
                            error={vehicleNoErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className={`col-lg-4 mb-2`}>
                        <InputElement
                            value={gpsImeiNo}
                            name="gpsImeiNo"
                            label={`GPS IMEI number`}
                            onChange={onChangeHandler}
                            placeholder={`Enter GPS IMEI number`}
                            error={gpsImeiNoErr}
                        />
                    </div>
                    <div className={`col-lg-4 mb-2`}>
                        <AsyncInputField
                            previewKey={"SearchItem"}
                            value={simIccidNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "SIM")}
                            name="simIccidNo"
                            label={"New Sim ICCID no."}
                            placeholder={"Search New Sim ICCID no."}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "simIccidNo" })}
                            error={simIccidNoErr}
                            setError={(err) => setErrorGps("simIccidNo", err)}
                        />
                    </div>
                    <div className={`col-lg-6 mb-2`}>
                        <InputElement
                            disable={true}
                            value={simNum}
                            name="simNum"
                            label={`SIM Number`}
                            onChange={onChangeHandler}
                            placeholder={`Enter SIM Number`}
                            error={simNumErr}
                        />
                    </div>
                    <div className={`col-lg-6 mb-2`}>
                        <InputElement
                            type="date"
                            label={"Vehicle Expiry Date"}
                            placeholder={"Enter Expiry Date"}
                            name={"expiryDate"}
                            value={expiryDate}
                            isRequired={false}
                            error={false}
                            onChange={onChangeHandler}
                        />
                    </div>
                </> : requestType == 6 ? <>
                    <div className={`col-lg-6 mb-2`}>
                        <AsyncInputField
                            previewKey={"vehicleRegno"}
                            value={vehicleNo}
                            fetchSuggestions={(query) => fetchSuggestions(query, "vehicle")}
                            name="vehicleNo"
                            label={"Vehicle reg no"}
                            placeholder={"Search Vehicle reg no"}
                            onChange={onChangeHandler}
                            onSelect={(data) => handleDropDownSelect({ ...data, name: "vehicleNo" })}
                            error={vehicleNoErr}
                            setError={(err) => setErrorGps("vehicleNo", err)}
                        />
                    </div>
                    <div className={`col-lg-6 mb-2`}>
                        <InputElement
                            disable={true}
                            value={gpsImeiNo}
                            name="gpsImeiNo"
                            label={`GPS IMEI number`}
                            onChange={onChangeHandler}
                            placeholder={`Enter GPS IMEI number`}
                            error={gpsImeiNoErr}
                        />
                    </div> </> : requestType == 7 ? <>
                        <div className={`col-lg-3 mb-2`}>
                            <AsyncInputField
                                previewKey={"vehicleRegno"}
                                value={vehicleNo}
                                fetchSuggestions={(query) => fetchSuggestions(query, "vehicle")}
                                name="vehicleNo"
                                label={"Vehicle reg no"}
                                placeholder={"Search Vehicle reg no"}
                                onChange={onChangeHandler}
                                onSelect={(data) => handleDropDownSelect({ ...data, name: "vehicleNo" })}
                                error={vehicleNoErr}
                                setError={(err) => setErrorGps("vehicleNo", err)}
                            />
                        </div>
                        <div className={`col-lg-3 mb-2`}>
                            <InputElement
                                disable={true}
                                value={simIccidNo}
                                name="simIccidNo"
                                label={`Existing GPS IMEI number`}
                                onChange={onChangeHandler}
                                placeholder={`Existing GPS IMEI number`}
                                error={simIccidNoErr}
                            />
                        </div>
                        <div className={`col-lg-3 mb-2`}>
                            <AsyncInputField
                                previewKey={"SearchItem"}
                                value={gpsImeiNo}
                                fetchSuggestions={(query) => fetchSuggestions(query, "GPS")}
                                name="gpsImeiNo"
                                label={`GPS IMEI number`}
                                onChange={onChangeHandler}
                                onSelect={(data) => handleDropDownSelect({ ...data, name: "gpsImeiNo" })}
                                placeholder={`Search GPS IMEI number`}
                                error={gpsImeiNoErr}
                                setError={(err) => setErrorGps("gpsImeiNo", err)}
                            />
                        </div>
                        <div className={`col-lg-3 mb-2`}>
                            <InputElement
                                disable={true}
                                value={simNum}
                                name="simNum"
                                label={`SIM Number`}
                                onChange={onChangeHandler}
                                placeholder={`Enter SIM Number`}
                                error={simNumErr}
                            />
                        </div>
                    </> : null}
            </div>
        </div>
        {isUpdate ? null : <div className="col-lg-1 text-center">
            <ButtonElement text={isCompleted ? <FaX size={"16px"} /> : <FaPlus size={"16px"} />} cssClass="small-radius plus-btn" onClick={isCompleted ? removeItem : addItems} variant="btn-outline-primary" />
        </div>}
    </div>
}

export default RequestItem;